/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Container,
  Stack,
  TextField,
  ButtonGroup,
  Grid,
  MenuItem,
  Typography,
  Card,
  IconButton,
  Tooltip,
  Button
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import { ToastContainer, toast } from 'react-toastify';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import services from '../../Service';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from '../../../Common/AlertDialog';
import ImageUploader from 'react-images-upload';
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { PhoneNumberUtil } from 'google-libphonenumber';

var screenCode = "FARMER"

export function Business({ handleNext, handleBack, farmerId }) {
  const [message, setMessage] = useState('Delete Confirmation');
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [farmerBusinessDetailsID, setFarmerBusinessDetailsID] = useState();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
});
  const [dataGrid, setDataGrid] = useState([]);
  const [lenderTypeID, setlenderTypeID] = useState();
  const [factoryType, setFactoryType] = useState(0);
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [gnDivisionList, setGnDivisionList] = useState([]);
  const [dsDivisionList, setDsDivisionList] = useState([]);
  const today = new Date().toISOString().split('T')[0];
  const [ImageObject, setImageObject] = useState(null);
  const [isButtonEnable, setIsButtonEnable] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [groupFactory, setGroupFactory] = useState([]);
  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const [allDisableButton, setAllDisableButton] = useState(false);
  const [formData, setFormData] = useState({
    farmerID: 0,
    businessName: '',
    address1: '',
    address2: '',
    province: 0,
    district: 0,
    city: 0,
    gnDivisionID: 0,
    dsDivisionID: 0,
    regNumber: '',
    regDate: today,
    primaryContactNumber: '',
    secondnumber: '',
    email: '',
    businessExpertise: 0,
    numOfEmp: '',
    typeOfBusiness: 0,
    image: ''
  });
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    Edit: false,
    submitButtonName: 'Add',
    pageheadername: 'Add Business Details '
  });

  let ProductSaveSchema = Yup.object()
  if (allDisableButton) {
    ProductSaveSchema = Yup.object().shape({
      businessName: Yup.string().required('Business Name required')
        .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
          if (value && value.startsWith(' ')) {
            return false;
          }
          return true;
        }),
      address1: Yup.string()
        .when({
          is: (allDisableButton),
          then: Yup.string().required('Address 1 required')
            .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
              if (value && value.startsWith(' ')) {
                return false;
              }
              return true;
            }),
          otherwise: Yup.string().nullable(),
        }),
      address2: Yup.string()
        .when({
          is: (allDisableButton),
          then: Yup.string().required('Address 2 required')
            .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
              if (value && value.startsWith(' ')) {
                return false;
              }
              return true
            }),
          otherwise: Yup.string().nullable(),
        }),
      province: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'Province Required').required('province Required'),
          otherwise: Yup.number().nullable(),
        }),


      district: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'District Required').required('district Required'),
          otherwise: Yup.number().nullable(),
        }),
      city: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'City Required').required('title Required'),
          otherwise: Yup.number().nullable(),
        }),
      dsDivisionID: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'DS Division Required').required('dsDivisionID Required'),
          otherwise: Yup.number().nullable(),
        }),
      gnDivisionID: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'GN Division Required').required('gnDivisionID Required'),
          otherwise: Yup.number().nullable(),
        }),
      typeOfBusiness: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'Type of Business Required').required('typeOfBusiness Required'),
          otherwise: Yup.number().nullable(),
        }),

      regNumber: Yup.string().required('Registration Number required'),

      regDate: Yup.string()
        .when({
          is: (allDisableButton),
          then: Yup.string().required('Date of Business Registration required'),
          otherwise: Yup.string().nullable(),
        }),
      primaryContactNumber: Yup.string()
        .when({
          is: (allDisableButton),
          then: Yup
            .string()
            .test('phone-number', 'Invalid phone number', (value) =>
              validatePhoneNumber(value))
            .test('no-leading-space', 'Leading space not allowed', (value) => {
              if (value && value.startsWith(' ')) {
                return false;
              }
              return true;
            }),
          otherwise: Yup.string().nullable(),
        }),

      numOfEmp: Yup.string()
        .when({
          is: (allDisableButton),
          then: Yup.string().required('Agri Employees required').matches(/^[0-9\b]+$/, 'Only allow numbers'),
          otherwise: Yup.string().nullable(),
        }),
      email: Yup.string().nullable(true).matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g, 'Not a valid E-Mail Address'),
      businessExpertise: Yup.number()
        .when({
          is: (allDisableButton),
          then: Yup.number().min(1, 'Areas of Specialization Required').required('Areas of Specialization Required'),
          otherwise: Yup.number().nullable(),
        }),
      secondnumber: Yup.string().matches(/^[0-9]{10}$/, 'Invalid Mobile Number').nullable(),
    });

  }
  else {

    ProductSaveSchema = Yup.object().shape({
      businessName: Yup.string().required('Business Name required')
        .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
          if (value && value.startsWith(' ')) {
            return false;
          }
          return true;
        }),
      address1: Yup.string().required('Address 1 required')
        .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
          if (value && value.startsWith(' ')) {
            return false;
          }
          return true;
        }),
      address2: Yup.string().required('Address 2 required')
        .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
          if (value && value.startsWith(' ')) {
            return false;
          }
          return true;
        }),
      province: Yup.number().min(1, 'Province Required').required('province Required'),
      district: Yup.number().min(1, 'District Required').required('district Required'),
      city: Yup.number().min(1, 'City Required').required('title Required'),
      dsDivisionID: Yup.number().min(1, 'DS Division Required').required('dsDivisionID Required'),
      gnDivisionID: Yup.number().min(1, 'GN Division Required').required('gnDivisionID Required'),
      typeOfBusiness: Yup.number().min(1, 'Type of Business Required').required('typeOfBusiness Required'),
      regNumber: Yup.string().required('Registration Number required'),
      regDate: Yup.string().required('Date of Business Registration required'),
      primaryContactNumber: Yup
        .string()
        .test('phone-number', 'Invalid phone number', (value) =>
          validatePhoneNumber(value))
        .test('no-leading-space', 'Leading space not allowed', (value) => {
          if (value && value.startsWith(' ')) {
            return false;
          }
          return true;
        }),
      numOfEmp: Yup.string().required('Agri Employees required').matches(/^[0-9\b]+$/, 'Only allow numbers'),
      email: Yup.string().nullable(true).matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g, 'Not a valid E-Mail Address'),
      businessExpertise: Yup.number().min(1, 'Areas of Specialization Required').required('Areas of Specialization Required'),
      secondnumber: Yup.string().matches(/^[0-9]{10}$/, 'Invalid Mobile Number').nullable(),
    });

  }

  const formik = useFormik({
    initialValues: {
      farmerID: farmerId,
      businessName: formData.businessName,
      address1: formData.address1,
      address2: formData.address2,
      province: formData.province,
      district: formData.district,
      city: formData.city,
      dsDivisionID: formData.dsDivisionID,
      gnDivisionID: formData.gnDivisionID,
      regNumber: formData.regNumber,
      regDate: formData.regDate,
      primaryContactNumber: formData.primaryContactNumber,
      secondnumber: formData.secondnumber,
      email: formData.email,
      businessExpertise: formData.businessExpertise,
      numOfEmp: formData.numOfEmp,
      typeOfBusiness: formData.typeOfBusiness,
      image: formData.image
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {

      if (allDisableButton || (!allDisableButton && values.image !== '')) {
        setIsButtonEnable(true);
        addGrid(values);
      } else {
        toast.error("Please Add a Business Registration Image");
      }
    },
    enableReinitialize: true
  });


  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  useEffect(() => {
    getPermissions();
}, []);

  useEffect(() => {
    setlenderTypeID(formik.values.lenderTypeID);
  }, [formik.values.lenderTypeID]);

  useEffect(() => {
    trackPromise(GetAllBusinessDetailsbyFarmerID(farmerId));
    GetModeofOperationbyFarmerID(farmerId);
  }, []);

  useEffect(() => {
    getProvinceForDropdown();
  }, []);

  useEffect(() => {
    getDistrictForDropdown();
  }, [formik.values.province]);

  useEffect(() => {
    getCityForDropdown();
  }, [formik.values.province, formik.values.district]);

  useEffect(() => {
    getDsDivisionsForDropdown();
  }, [formik.values.province, formik.values.district, formik.values.city]);

  useEffect(() => {
    getGnDivisionsForDropdown();
  }, [formik.values.province, formik.values.district, formik.values.city, formik.values.dsDivisionID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

    if (isAuthorized === undefined) {
        navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
        ...permissionList,
        isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    setGroupFactory({
        ...groupFactory,
        groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))


}
  async function GetModeofOperationbyFarmerID(farmerId) {
    const res = await services.GetModeofOperationbyFarmerID(farmerId)
    if (res == 2) {
      setAllDisableButton(true)
    }
    else {
      setAllDisableButton(false)
    }
  }

  async function GetAllBusinessDetailsbyFarmerID(farmerId) {
    const res = await services.GetAllBusinessDetailsbyFarmerID(farmerId);
    setDataGrid(res)
  }

  async function getProvinceForDropdown() {
    const province = await services.GetProvinceForDropdown();
    setProvinceList(province);
  }

  async function getDistrictForDropdown() {
    const district = await services.GetDistrictForDropdown(formik.values.province);
    setDistrictList(district);
  }

  async function getCityForDropdown() {
    const city = await services.GetCityForDropdown(formik.values.province, formik.values.district);
    setCityList(city);
  }

  async function getDsDivisionsForDropdown() {
    if (formik.values.province != 0 && formik.values.district != 0 && formik.values.city != 0) {
      let model = {
        provinceID: parseInt(formik.values.province),
        districtID: parseInt(formik.values.district),
        cityID: parseInt(formik.values.city)
      }
      const dsDivision = await services.GetDsDivisionsForDropdown(model);
      setDsDivisionList(dsDivision);
    }
  }

  async function removeImage() {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setImageObject(null);
    setValues({
      ...values,
      image: ""
    });
    setOpen(false);
  }

  function onDrop(picture, imageUrl) {
    if (imageUrl.length == 0) {
      toast.error("Image not supported");
      return;
    }
    else {
      var convertedString = imageUrl[0];
      var fields = convertedString.split(",");
      var fields2 = fields[0].split(";");
      var fields3 = fields2[1].split("=");
      var fields4 = fields3[1].split(".");

      setImageObject(fields[1]);
      setValues({
        ...values,
        image: fields[1]
      });
    }
  }

  async function getGnDivisionsForDropdown() {
    if (formik.values.province != 0 && formik.values.district != 0 && formik.values.city != 0 && formik.values.dsDivisionID != 0) {
      let model = {
        provinceID: parseInt(formik.values.province),
        districtID: parseInt(formik.values.district),
        cityID: parseInt(formik.values.city),
        dsDivisionID: parseInt(formik.values.dsDivisionID)
      }
      const gnDivision = await services.GetGnDivisionsForDropdown(model);
      setGnDivisionList(gnDivision);
    }
  }

  async function addGrid(values) {
    const exists = dataGrid.find(
      (x) =>
        x.businessName === values.businessName &&
        x.address1 === values.address1 &&
        x.address2 === values.address2 &&
        x.province === parseInt(values.province) &&
        x.district === parseInt(values.district) &&
        x.dsDivisionID === parseInt(values.dsDivisionID) &&
        x.gnDivisionID === parseInt(values.gnDivisionID) &&
        x.typeOfBusiness === parseInt(values.typeOfBusiness) &&
        x.city === parseInt(values.city) &&
        x.regNumber === values.regNumber &&
        x.regDate === values.regDate &&
        x.secondnumber === values.secondnumber &&
        x.email === values.email &&
        x.businessExpertise === parseInt(values.businessExpertise) &&
        x.numOfEmp === parseInt(values.numOfEmp) &&
        x.primaryContactNumber === values.primaryContactNumber
    );
    if (exists) {
      toast.error('Details Already Exists.');
    } else {
      if (pageProps.Edit != true) {
        var modelOne = {
          farmerBusinessDetailsID: parseInt(0),
          farmerID: parseInt(values.farmerID),
          businessName: values.businessName,
          address1: values.address1,
          address2: values.address2,
          province: parseInt(values.province),
          district: parseInt(values.district),
          city: parseInt(values.city),
          dsDivisionID: parseInt(values.dsDivisionID),
          gnDivisionID: parseInt(values.gnDivisionID),
          typeOfBusiness: parseInt(values.typeOfBusiness),
          regNumber: values.regNumber,
          regDate: values.regDate,
          primaryContactNumber: values.primaryContactNumber,
          secondnumber: values.secondnumber,
          email: values.email,
          createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
          businessExpertise: parseInt(values.businessExpertise),
          numOfEmp: values.numOfEmp == "" ? 0 : parseInt(values.numOfEmp),
          image: values.image

        };
        const res = await services.SaveFarmerBusinessDetail(modelOne);
        if (res.data > 0) {
          toast.success('Business Details Saved Succesfully');
          setIsButtonEnable(false)
          trackPromise(GetAllBusinessDetailsbyFarmerID(farmerId));
          clearAll();
        } else {
          toast.error('Error Occured In Farmer Business Details Saving.');
        }
      } else {
        var modelOne = {
          farmerBusinessDetailsID: parseInt(pageProps.editingID),
          farmerID: parseInt(values.farmerID),
          businessName: values.businessName,
          address1: values.address1,
          address2: values.address2,
          province: parseInt(values.province),
          district: parseInt(values.district),
          city: parseInt(values.city),
          dsDivisionID: parseInt(values.dsDivisionID),
          gnDivisionID: parseInt(values.gnDivisionID),
          typeOfBusiness: parseInt(values.typeOfBusiness),
          regNumber: values.regNumber,
          regDate: values.regDate,
          primaryContactNumber: values.primaryContactNumber,
          secondnumber: values.secondnumber == null ? "" : values.secondnumber,
          email: values.email == null ? "" : values.email,
          createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
          businessExpertise: parseInt(values.businessExpertise),
          numOfEmp: values.numOfEmp == "" ? 0 : parseInt(values.numOfEmp),
          image: values.image == null ? "" : values.image
        };
        const res = await services.UpdateFarmerBusinessDetail(modelOne);
        if (res.statusCode == 'Success') {
          toast.success('Business Details Updated Succesfully');
          setIsButtonEnable(false)
          trackPromise(GetAllBusinessDetailsbyFarmerID(farmerId));
          setPageProps({
            ...pageProps,
            editingID: 0,
            Edit: false,
            submitButtonName: 'Add'
          });
          clearAll();
        } else {
          toast.error('Error occured in Farmer Business Details.');
        }
      }
    }
  }

  function validatePhoneNumber(phoneNumber) {
    try {
      const number = phoneNumberUtil.parseAndKeepRawInput(phoneNumber, 'LK');
      return phoneNumberUtil.isValidNumber(number);
    } catch (error) {
      return false;
    }
  };

  async function clearAll() {
    formik.resetForm();
    setImageObject(null)
  }

  async function DeleteItem(data) {
    const res = await services.DeleteFarmerBusinessDetail(data);
    if (res.data > 0) {
      toast.success('Business Deleted Succesfully');
      trackPromise(GetAllBusinessDetailsbyFarmerID(farmerId));
    } else {
      toast.error("Error Occured When Delete Business Details");
    }
  }

  function confirmData(y) {
    if (y) {
      DeleteItem(farmerBusinessDetailsID);
    }
  }

  function handleConfirm(data) {
    setFarmerBusinessDetailsID(data);
    setEnableConfirmMessage(true);
  }

  function handleEdit(rowData, index) {
    var array = [...dataGrid];
    setValues({
      ...values,
      businessName: rowData.businessName,
      address1: rowData.address1,
      address2: rowData.address2,
      province: rowData.province,
      district: rowData.district,
      city: rowData.city,
      dsDivisionID: rowData.dsDivisionID,
      gnDivisionID: rowData.gnDivisionID,
      regNumber: rowData.regNumber,
      regDate: rowData.regDate == null ? null : new Date(rowData.regDate).toISOString().split('T')[0],
      primaryContactNumber: rowData.primaryContactNumber,
      secondnumber: rowData.secondnumber,
      email: rowData.email,
      businessExpertise: rowData.businessExpertise,
      typeOfBusiness: rowData.typeOfBusiness,
      numOfEmp: rowData.numOfEmp,
      image: rowData.image
    });

    array.splice(index, 1);
    setImageObject(rowData.image == "" ? null : rowData.image)
    setPageProps({
      ...pageProps,
      editingID: rowData.farmerBusinessDetailsID,
      Edit: true,
      submitButtonName: 'Update'
    });
    setDataGrid(array);
  }

  function generateProvinceDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.provinceID} value={x.provinceID}>{x.provinceName}</MenuItem>)
      });
    }
    return items
  }

  function generateDistrictDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.districtID} value={x.districtID}>{x.districtName}</MenuItem>)
      });
    }
    return items
  }

  function generateCityDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.cityID} value={x.cityID}>{x.cityName}</MenuItem>)
      });
    }
    return items
  }

  function generateDsDivisionDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.dsDivisionID} value={x.dsDivisionID}>{x.dsDivisionName}</MenuItem>)
      });
    }
    return items
  }

  function generateGnDivisionDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.gnDivisionID} value={x.gnDivisionID}>{x.gnDivisionName}</MenuItem>)
      });
    }
    return items
  }
  return (
    <>
      <LoadingComponent />
      <Page title="Business Details |  FAPS">
        <Container>
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Card style={{ justifycontent: 'center' }}>
                <Stack spacing={2} margin={3}>
                  <Typography variant="h6">

                    {(factoryType == 1 || factoryType == 3) ? "View Business Details" : "Business Details"}
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right">
                      <ButtonGroup disableElevation variant="outlined" color="primary">
                        <Tooltip title="Supplier Produce">
                          <IconButton variant="outlined" color="secondary" onClick={handleBack}>
                            <ArrowBackIosOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cargills Connect">
                          <IconButton variant="outlined" color="secondary" onClick={handleNext}>
                            <ArrowForwardIosOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </ButtonGroup>
                    </Stack>
                  </Typography>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    style={{ marginTop: '25px' }}
                    spacing={2}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      label="Business Name *"
                      value={formik.values.businessName}
                      onChange={formik.handleChange}
                      {...getFieldProps('businessName')}
                      error={Boolean(touched.businessName && errors.businessName)}
                      helperText={touched.businessName && errors.businessName}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 }
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Type of Business *"
                      name="typeOfBusiness"
                      value={formik.values.typeOfBusiness}
                      onChange={formik.handleChange}
                      {...getFieldProps('typeOfBusiness')}
                      error={Boolean(touched.typeOfBusiness && errors.typeOfBusiness)}
                      helperText={touched.typeOfBusiness && errors.typeOfBusiness}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0}>Select Type of Business</MenuItem>
                      <MenuItem value={1}> Individual</MenuItem>
                      <MenuItem value={2}> Partnership</MenuItem>
                      <MenuItem value={3}> Private Limited Company</MenuItem>

                    </TextField>
                    <TextField
                      fullWidth
                      size="small"
                      label="Business Registration Number *"
                      value={formik.values.regNumber}
                      onChange={formik.handleChange}
                      {...getFieldProps('regNumber')}
                      error={Boolean(touched.regNumber && errors.regNumber)}
                      helperText={touched.regNumber && errors.regNumber}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                    />
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    style={{ marginTop: '25px' }}
                    spacing={2}
                  >
                    <TextField
                      fullWidth
                      id="outlined-name"
                      size="small"
                      type="date"
                      label="Date of Business Registration *"
                      value={formik.values.regDate}
                      onChange={formik.handleChange}
                      {...getFieldProps('regDate')}
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(touched.regDate && errors.regDate)}
                      helperText={touched.regDate && errors.regDate}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                      inputProps={{
                        max: new Date().toISOString().split('T')[0], // This is the correct location for 'max'
                      }}
                    />
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Areas of Specialization *"
                      name="businessExpertise"
                      value={formik.values.businessExpertise}
                      onChange={formik.handleChange}
                      {...getFieldProps('businessExpertise')}
                      error={Boolean(touched.businessExpertise && errors.businessExpertise)}
                      helperText={touched.businessExpertise && errors.businessExpertise}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0}>Select Areas of Specialization</MenuItem>
                      <MenuItem value={1}> Agri</MenuItem>
                      <MenuItem value={2}> Diversified</MenuItem>

                    </TextField>
                    <TextField
                      fullWidth
                      size="small"
                      label="Agri Employees *"
                      value={formik.values.numOfEmp}
                      onChange={formik.handleChange}
                      {...getFieldProps('numOfEmp')}
                      error={Boolean(touched.numOfEmp && errors.numOfEmp)}
                      helperText={touched.numOfEmp && errors.numOfEmp}
                      disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                    />
                  </Stack>
                  <Divider variant="middle" />
                  <Typography variant="h8">
                    <b>{"Contact Number/s"}</b>
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2} style={{ marginTop: '25px' }}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Primary Contact Number *"
                      value={formik.values.primaryContactNumber}
                      onChange={formik.handleChange}
                      {...getFieldProps('primaryContactNumber')}
                      error={Boolean(touched.primaryContactNumber && errors.primaryContactNumber)}
                      helperText={touched.primaryContactNumber && errors.primaryContactNumber}
                      disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Secondary Contact Number "
                      value={formik.values.secondnumber}
                      onChange={formik.handleChange}
                      {...getFieldProps('secondnumber')}
                      error={Boolean(touched.secondnumber && errors.secondnumber)}
                      helperText={touched.secondnumber && errors.secondnumber}
                      disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Email Address"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      {...getFieldProps('email')}
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                      disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                    />
                  </Stack>
                  <Divider variant="middle" />
                  <Typography variant="h8">
                    <b>{"Business Address"}</b>
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2} style={{ marginTop: '25px' }}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Province *"
                      name="province"
                      value={formik.values.province}
                      onChange={formik.handleChange}
                      {...getFieldProps('province')}
                      error={Boolean(touched.province && errors.province)}
                      helperText={touched.province && errors.province}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key="0" value="0"> Select Province</MenuItem>
                      {generateProvinceDropDownMenu(provinceList)}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="District *"
                      name="district"
                      value={formik.values.district}
                      onChange={formik.handleChange}
                      {...getFieldProps('district')}
                      error={Boolean(touched.district && errors.district)}
                      helperText={touched.district && errors.district}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key="0" value="0"> Select District</MenuItem>
                      {generateDistrictDropDownMenu(districtList)}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="City *"
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      {...getFieldProps('city')}
                      error={Boolean(touched.city && errors.city)}
                      helperText={touched.city && errors.city}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key="0" value="0" > Select City</MenuItem>
                      {generateCityDropDownMenu(cityList)}

                    </TextField>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    style={{ marginTop: '25px' }}
                    spacing={2}
                  >
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="DS Divivion *"
                      name="dsDivisionID"
                      value={formik.values.dsDivisionID}
                      onChange={formik.handleChange}
                      {...getFieldProps('dsDivisionID')}
                      error={Boolean(touched.dsDivisionID && errors.dsDivisionID)}
                      helperText={touched.dsDivisionID && errors.dsDivisionID}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key="0" value="0" > Select DS Division</MenuItem>
                      {generateDsDivisionDropDownMenu(dsDivisionList)}

                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="GN Divivion *"
                      name="gnDivisionID"
                      value={formik.values.gnDivisionID}
                      onChange={formik.handleChange}
                      {...getFieldProps('gnDivisionID')}
                      error={Boolean(touched.gnDivisionID && errors.gnDivisionID)}
                      helperText={touched.gnDivisionID && errors.gnDivisionID}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key="0" value="0" > Select GN Division</MenuItem>
                      {generateGnDivisionDropDownMenu(gnDivisionList)}

                    </TextField>
                    <TextField
                      fullWidth
                      size="small"
                      label="Address 1 *"
                      value={formik.values.address1}
                      onChange={formik.handleChange}
                      {...getFieldProps('address1')}
                      error={Boolean(touched.address1 && errors.address1)}
                      helperText={touched.address1 && errors.address1}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    style={{ marginTop: '25px' }}
                    spacing={2}
                  >
                    <Grid item md={4} xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Address 2 *"
                        value={formik.values.address2}
                        onChange={formik.handleChange}
                        {...getFieldProps('address2')}
                        error={Boolean(touched.address2 && errors.address2)}
                        helperText={touched.address2 && errors.address2}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || allDisableButton}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}></Grid>
                    <Grid item md={4} xs={12}></Grid>
                  </Stack>
                  <Typography variant="h6">
                    Proof of Business Identity
                  </Typography>
                  <Stack spacing={2} margin={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Stack style={{ width: '250px' }}>
                        <ImageUploader
                          //withIcon={false}
                          singleImage={true}
                          //withPreview={true}
                          buttonText='Upload Business Reg Image'
                          onChange={onDrop}
                          image={formik.values.image}
                          imgExtension={['.jpg', '.png']}
                          maxFileSize={5242880}
                          hidden={allDisableButton}
                        />
                      </Stack>
                      {ImageObject != null ?
                        <Card>
                          <CardMedia
                            component="img"
                            height="140"
                            image={`data:image/jpeg;base64,${ImageObject}`}
                            {...getFieldProps('image')}
                            error={Boolean(touched.image && errors.image)}
                            helperText={touched.image && errors.image}
                          />
                          <Button
                            fullWidth
                            color="secondary"
                            type="button"
                            variant="contained"
                            onClick={removeImage}
                          >
                            Remove
                          </Button>
                          <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                          >
                            <DialogTitle id="alert-dialog-title">
                              {"Are you sure you want to delete this image?"}
                            </DialogTitle>

                            <DialogActions>
                              <Button onClick={handleClose}>No</Button>
                              <Button onClick={handleOpen}>Yes</Button>
                            </DialogActions>
                          </Dialog>
                        </Card> : null}

                    </Stack>
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="medium"
                      type="button"
                      variant="outlined"
                      color="error"
                      onClick={() => clearAll()}
                      disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="medium"
                      type="submit"
                      variant="outlined"
                      color="secondary"
                      disabled={factoryType == 1 || factoryType == 3 || isButtonEnable}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack>
                  <Divider variant="middle" />
                  {(dataGrid.length > 0) ?
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Card style={{ justifycontent: 'center', width: '65rem' }}>
                        <TableContainer component={Paper}>
                          <Table aria-label="caption table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Business Name</TableCell>
                                <TableCell>Registration Number</TableCell>
                                <TableCell>Type of Business</TableCell>
                                <TableCell>Business Reg Document</TableCell>
                                {(factoryType == 1 || factoryType == 3) ? null :
                                  <TableCell align="center">Action</TableCell>}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {dataGrid.map((rowData, index) => (
                                <TableRow key={index}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.businessName}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.regNumber}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.typeOfBusiness == 1 ? "Individual"
                                      : rowData.typeOfBusiness == 2 ? "Partnership"
                                        : rowData.typeOfBusiness == 2 ? "Private Limited Company"
                                          : " -- "}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row" style={{ borderBottom: "none" }}>
                                    {rowData.image !== "" && rowData.image !== null ? (
                                      <img src={`data:image/jpeg;base64,${rowData.image}`} alt={`Image ${index}`} style={{ width: '75px', height: 'auto', display: 'block', margin: '0 auto' }} align="center" />
                                    ) : (
                                      <span style={{ display: 'block', margin: '0 auto', textAlign: 'left' }}>{"--"}</span>
                                    )}
                                  </TableCell>

                                  {(factoryType == 1 || factoryType == 3) ? null :
                                    <TableCell
                                      align="center"
                                      component="th"
                                      scope="row"
                                      style={{ borderBottom: 'none' }}
                                    >
                                      {pageProps.Edit != true ? (
                                        <Tooltip title="Edit">
                                          <IconButton
                                            variant="outlined"
                                            onClick={() => handleEdit(rowData, index)}
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        </Tooltip>
                                      ) : null}
                                      <Tooltip title="Delete">
                                        <IconButton
                                          variant="outlined"
                                          color="error"
                                          onClick={(e) => handleConfirm(rowData.farmerBusinessDetailsID)}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </Stack>
                    : null}
                </Stack>
              </Card>
            </Form>
          </FormikProvider>
        </Container>
        <div hidden={true}>
          <Grid item>
            <AlertDialog
              confirmData={confirmData}
              headerMessage={message}
              viewPopup={EnableConfirmMessage}
              discription={'Are you sure want to delete Business Details ?'}
              setViewPopup={setEnableConfirmMessage}
            />
          </Grid>
        </div>
      </Page>
    </>
  );
}
